import React, { Component, createRef } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import Wizard from "./helpers/Wizard";
import * as actions from "../actions";
import Timeline from "./timeline";
import Step1 from "./treatment_steps/Step1";
import Step2 from "./treatment_steps/Step2";
import Step3 from "./treatment_steps/Step3";
import Step4 from "./treatment_steps/Step4";
import Step5 from "./treatment_steps/step5/Step5";

class TreatmentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            pdfUrl: false,
            treatmentFormItems: null,
        };
    }

    onSubmit = async (values) => {
        console.log(values);
        const reactState = this;
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }
        values.formType = "treatment";
        console.log("values");
        console.log(values);

        try {
            await Axios({
                method: "post",
                url: url + "api/generate_pdf",
                data: values,
                headers: {
                    "Content-type": "application/x-www-form-urlencoded",
                },
            }).then(function (res) {
                console.log("res", res);
                console.log(" res.data.file", res.data.file);
                sessionStorage.setItem("noAllergies", "");
                sessionStorage.setItem("noMedication", "");
                reactState.setState({
                    ...reactState.state,
                    pdfUrl: url + res.data.file,
                    submitted: true,
                });

                document.getElementById("before-submission").style.display =
                    "none";
                document.getElementById("start-form-message").style.display =
                    "none";
                document.getElementById("pick-form-component").style.display =
                    "none";
                document.getElementById(
                    "form-gradient-container"
                ).style.display = "none";
                document.getElementById(
                    "hcp-enrollment-footnote"
                ).style.display = "none";
                document.getElementById("after-submission").style.display =
                    "block";
            });
        } catch (errors) {
            console.log("errors", errors);
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            treatmentFormItems: {
                [name]: value,
            },
        });
    };

    toTop = createRef();

    render() {
        const { submitted, pdfUrl } = this.state;
        const { formRef } = this.props;
        const buttonLabels = [
            "Insurance information",
            "Diagnosis & Prescriber Information",
            "Prescription Information",
            "Authorization & submission",
        ];

        const { innerWidth: viewportWidth, innerHeight: viewportHeight } =
            window;
        // The steps timeline are ordered based on the following array

        let steps = [
            "PATIENT OR RESIDENT INFORMATION",
            "INSURANCE INFORMATION",
            "DIAGNOSIS & PRESCRIBER INFORMATION",
            "PRESCRIPTION INFORMATION",
            "AUTHORIZATION&nbsp;& SUBMISSION",
        ];

        /* mobile */
        if (viewportWidth <= 576) {
            steps = [
                "PATIENT OR RESIDENT INFORMATION",
                "INSURANCE INFORMATION",
                'DIAGNOSIS & PRESCRIBER<br class="mobile-break"> INFORMATION',
                "PRESCRIPTION INFORMATION",
                "AUTHORIZATION & SUBMISSION",
            ];
        }

        const formIdentifier = "TreatmentForm";

        return (
            <div className="acadia-form" id="treatment-form">
                <div className="container">
                    <div className="row spacer-small">&nbsp;</div>
                </div>
                <div
                    id="form-gradient-container"
                    className="container-fluid form-gradient"
                >
                    <div className="container">
                        <Timeline steps={steps} />
                    </div>
                </div>
                <div className="container">
                    <div id="formTop" ref={this.toTop}>
                        <div className="row">
                            <div className="col-lg-7 ml-3">
                                <Wizard
                                    onSubmit={this.onSubmit}
                                    buttonLabels={buttonLabels}
                                    formIdentifier={formIdentifier}
                                    formRef={formRef}
                                    noOfPages={5}
                                    toTop={this.toTop}
                                    submitted={submitted}
                                >
                                    <Wizard.Page>
                                        <Step1 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step2 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step3 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step4 />
                                    </Wizard.Page>
                                    <Wizard.Page>
                                        <Step5
                                            submitted={submitted}
                                            pdfUrl={pdfUrl}
                                        />
                                    </Wizard.Page>
                                </Wizard>
                            </div>
                            <div className="col-lg-4">
                                <div className="floating-cta">
                                    <div className="placeholder">
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <a href="tel:18447372223">
                                            <img src="/images/floating-cta-hcp-placeholder.png" />
                                        </a>
                                        <div>
                                            Monday&ndash;Friday, 8:00 am to 8:00
                                            pm ET
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                        <div class="row spacer-large mobile">
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep } = state;
    return { currentStep: currentStep };
};

export default connect(mapStateToProps, actions)(TreatmentForm);
